import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllControleResiduoUseCase } from "../../../presentation/useCases/read/get_all_controle_residuo_use_case";
import {
  ControleResiduoItemModel,
  GetAllControleResiduoResponseModel,
  GetAllControleResiduoRequestModel,
} from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

export class GetAllControleResiduoUseCase extends BasePaginatedUseCase<ControleResiduoItemModel> implements IGetAllControleResiduoUseCase {
  // Armazenar o response completo
  public responseData?: GetAllControleResiduoResponseModel;

  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllControleResiduo(model: GetAllControleResiduoRequestModel): Promise<GetAllControleResiduoResponseModel> {
    const response = await this.repository.getAllControleResiduo(model);

    // ainda mantém paginação e items pra uso do BasePaginatedUseCase
    this._items = response.pagedItens.items;
    this._totalPages = response.pagedItens.totalPages;
    this._totalItems = response.pagedItens.totalItems;
    this._currentPage = response.pagedItens.currentPage;
    this._pageSize = response.pagedItens.pageSize;

    return response;
  }
}
